/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import { Spin } from '../loading';

export default function Button(props) {
  let defaultClassName;
  if (props.secondary) {
    if (props.loading || props.disabled) {
      defaultClassName = 'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white focus:outline-none cursor-auto';
    } else {
      defaultClassName = 'inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none';
    }
  } else if (props.loading || props.disabled) {
    defaultClassName = 'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-700 bg-neutral-40 focus:outline-none cursor-auto';
  } else if (props.custom) {
    defaultClassName =
      "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm focus:outline-none";
  } else {
    defaultClassName = 'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary focus:outline-none hover:bg-primary-20';
  }

  return (
    <button
      type="button"
      style={props.style}
      className={`${props.className} ${defaultClassName}`}
      onClick={props.onClick}
      disabled={props.disabled || props.loading}
    >
      {!props.loading ? null : <Spin size="xs" className="mr-1" />}
      {props.loading ? props.loadingTitle || 'Loading' : props.title}
    </button>
  );
}
